/**
 * GardenWarden target parade — demo toggles for targeting settings.
 * Client-side only; persists in sessionStorage for the tab.
 */
(function () {
  const STORAGE_KEY = "gwb-parade-targets";
  const LABELS = {
    squirrel: "Squirrel",
    rat: "Rat",
    deer: "Deer",
    pigeon: "Pigeon",
    cat: "Cat",
    dog: "Dog",
    people: "People",
  };

  function readStored() {
    try {
      const raw = sessionStorage.getItem(STORAGE_KEY);
      if (!raw) return null;
      const parsed = JSON.parse(raw);
      return parsed && typeof parsed === "object" ? parsed : null;
    } catch (_) {
      return null;
    }
  }

  function writeStored(map) {
    try {
      sessionStorage.setItem(STORAGE_KEY, JSON.stringify(map));
    } catch (_) {
      /* ignore quota / private mode */
    }
  }

  function applyState(btn, on) {
    const animal = btn.getAttribute("data-gwb-animal") || "target";
    const label = LABELS[animal] || animal;
    btn.setAttribute("data-gwb-on", on ? "true" : "false");
    btn.setAttribute("aria-pressed", on ? "true" : "false");
    btn.classList.toggle("gwb__parade-item--target", on);
    btn.classList.toggle("gwb__parade-item--safe", !on);
    btn.setAttribute(
      "aria-label",
      label + " targeting " + (on ? "on" : "off") + ". Tap to change."
    );
  }

  function collectState(root) {
    const map = {};
    root.querySelectorAll("[data-gwb-animal]").forEach((btn) => {
      if (btn.closest(".gwb__parade-dup")) return;
      const key = btn.getAttribute("data-gwb-animal");
      map[key] = btn.getAttribute("data-gwb-on") === "true";
    });
    return map;
  }

  function syncAnimal(root, animal, on) {
    root.querySelectorAll('[data-gwb-animal="' + animal + '"]').forEach((btn) => {
      applyState(btn, on);
    });
  }

  function showToast(toast, text) {
    if (!toast) return;
    toast.textContent = text;
    toast.classList.add("is-on");
    clearTimeout(showToast._t);
    showToast._t = setTimeout(() => {
      toast.classList.remove("is-on");
    }, 2200);
  }

  function initRoot(root) {
    const toast = root.querySelector("[data-gwb-parade-toast]");
    const stored = readStored();

    if (stored) {
      // People targeting is unsupported, so never restore it as enabled.
      if (stored.people) {
        stored.people = false;
        writeStored(stored);
      }
      Object.keys(stored).forEach((animal) => {
        syncAnimal(root, animal, animal === "people" ? false : !!stored[animal]);
      });
    }

    // Keep the unsupported target disabled even if the markup changes later.
    syncAnimal(root, "people", false);

    // Dup strip is decorative for the scroll loop — keep out of tab order.
    root.querySelectorAll(".gwb__parade-dup [data-gwb-animal]").forEach((btn) => {
      btn.setAttribute("tabindex", "-1");
    });

    root.addEventListener("click", (event) => {
      const btn = event.target.closest("[data-gwb-animal]");
      if (!btn || !root.contains(btn)) return;
      event.preventDefault();
      const animal = btn.getAttribute("data-gwb-animal");

      if (animal === "people") {
        syncAnimal(root, animal, false);
        writeStored(collectState(root));
        showToast(toast, "Targeting people is not supported. The system disarms and pauses when a person is detected.");
        return;
      }

      const next = btn.getAttribute("data-gwb-on") !== "true";
      syncAnimal(root, animal, next);
      writeStored(collectState(root));
      const label = LABELS[animal] || animal;
      showToast(
        toast,
        label + ": " + (next ? "on" : "off") + " · targeting settings updated"
      );
    });
  }

  function initAll() {
    document.querySelectorAll("[data-gwb-targets]").forEach(initRoot);
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", initAll);
  } else {
    initAll();
  }
})();
